
const CAR_MODELS = { 
  "Hyundai": { 
  "Alcazar": "Medium", 
  "Accent": "Medium", 
  "Eon": "Small", 
  "Venue": "Medium", 
  "Verna": "Medium",
  "i20": "Small", 
  "Grand i10 Nios": "Small", 
  "SantaFe": "Large", 
  "Elite i20": "Small",
  "All New i20": "Small", 
  "i10": "Small", 
  "Grand i10": "Small", 
  "Aura": "Medium",
  "XCent": "Medium", 
  "Creta": "Medium", 
  "Santro": "Small", 
  "Tucson": "Large",
  "Elantra": "Medium", 
  "Kona Electric": "Medium", 
  "Ioniq 5": "Medium", 
  "Ioniq 6": "Large",
  "Ioniq 9": "Large"
  },
  "NIO": { 
  "ES6": "Large", 
  "ES8": "Large", 
  "ET7": "Large", 
  "EC6": "Large"
  },
  "isuzu": { 
  "D-Max": "Large"
  },
  "Volvo": { 
  "XC40": "Medium", 
  "XC60": "Large", 
  "XC90": "Large", 
  "XC40 Recharge": "Medium",
  "C40 Recharge": "Large", 
  "S60": "Large", 
  "S90": "Large", 
  "V60": "Large",
  "V90 Cross Country": "Large", 
  "EX30": "Large", 
  "EX90": "Large", 
  "XC40 Recharge (Electric)": "Large"
  },
  "BYD": { 
  "Seal": "Large", 
  "Atto 3": "Medium", 
  "E6": "Large", 
  "Atto 3 Facelift": "Large",
  "Han EV": "Large", 
  "Tang EV": "Large", 
  "Dolphin": "Small", 
  "Sea Lion 07": "Large"
  },
  "Maruti": { 
  "Alto K10": "Small", 
  "Eeco": "Large", 
  "Ertiga": "Large", 
  "Zen Estilo": "Small",
  "Baleno": "Small", 
  "Baleno RS": "Small", 
  "Invicto": "Medium", 
  "Fronx": "Medium",
  "A-Star": "Small", 
  "Omni": "Medium", 
  "Swift Dzire": "Medium", 
  "Ritz": "Small",
  "Alto 800": "Small", 
  "Celerio": "Small", 
  "Ciaz": "Medium", 
  "Ignis": "Small",
  "Swift": "Small", 
  "XL6": "Medium", 
  "Grand Vitara (New)": "Medium", 
  "S-Presso": "Small",
  "Wagon R": "Small", 
  "Kizashi": "Medium", 
  "S-Cross": "Medium", 
  "Grand Vitara (Old)": "Medium",
  "SX4": "Medium", 
  "Brezza": "Medium", 
  "S-Cross 1.6": "Medium", 
  "Jimny": "Medium",
  "GranTurismo Folgore": "Large"
  },
  "Tata": { 
  "Nexon": "Medium", 
  "Curvv": "Large", 
  "Tigor": "Small", 
  "Altroz": "Small",
  "Punch": "Small", 
  "Harrier": "Large", 
  "Safari": "Large", 
  "Zest": "Medium",
  "Bolt": "Small", 
  "Indica": "Small", 
  "Manza": "Medium", 
  "Tiago": "Small",
  "Hexa": "Large", 
  "Safari Storme": "Large", 
  "Nano": "Small", 
  "Nexon EV": "Medium",
  "Tiago EV": "Small", 
  "Tigor EV": "Small", 
  "sumo victa": "Large"
  },
  "Honda": { 
  "City": "Medium", 
  "Amaze": "Medium", 
  "Accord": "Large", 
  "Jazz": "Small",
  "BRV": "Medium", 
  "CR-V": "Large", 
  "Brio": "Small", 
  "Civic (New)": "Medium",
  "WR-V": "Medium", 
  "Civic (Old)": "Medium", 
  "Elevate": "Medium", 
  "Xcent": "Medium",
  "e:HEV (Hybrid)": "Medium", 
  "Honda e": "Medium"
  },
  "Range Rover": { 
  "Range Rover": "Large", 
  "Range Rover Sport": "Large", 
  "Range Rover Velar": "Large",
  "Range Rover Evoque": "Large", 
  "Range Rover SV": "Large", 
  "Range Rover Electric": "Large"
  },
  "Mahindra": { 
  "Supro": "Large", 
  "Marazzo": "Large", 
  "Scorpio": "Large", 
  "TUV300": "Large",
  "XUV 500": "Large", 
  "Bolero": "Large", 
  "Alturas": "Large", 
  "XUV700": "Large",
  "Thar": "Large", 
  "KUV100": "Small", 
  "XUV 300": "Medium", 
  "Quanto": "Large",
  "Bolero Neo": "Large", 
  "Reva i": "Small", 
  "Reva i-GO": "Small", 
  "E2o Plus": "Small",
  "3XO AX5": "Medium", 
  "Scorpio Classic": "Large", 
  "Scorpio N": "Large", 
  "Verito": "Medium",
  "eKUV100": "Medium", 
  "XUV400 EV": "Medium", 
  "BE 6": "Large", 
  "XUV.e9": "Large"
  },
  "Renault": { 
  "Kwid": "Small", 
  "Triber": "Medium", 
  "Fluence": "Medium", 
  "Scala": "Medium",
  "Pulse": "Medium", 
  "Kiger": "Medium", 
  "Koleos": "Medium", 
  "Captur": "Medium",
  "Logan": "Medium", 
  "Duster": "Medium", 
  "Zoe": "Small", 
  "Megane E-Tech Electric": "Small"
  },
  "Volkswagen": { 
  "Taigun": "Large", 
  "TROC": "Large", 
  "Polo GT": "Small", 
  "Jetta": "Medium",
  "Tiguan": "Large", 
  "Ameo": "Medium", 
  "Vento": "Medium", 
  "Virtus": "Medium",
  "Passat": "Medium", 
  "Polo": "Small", 
  "ID. 3": "Large", 
  "ID. 4": "Large",
  "ID. Buzz": "Large", 
  "ID.2all": "Large"
  },
  "Skoda": { 
  "Kushaq": "Medium", 
  "Octavia": "Medium", 
  "Kodiaq": "Medium", 
  "Rapid": "Medium",
  "Slavia": "Medium", 
  "Fabia": "Small", 
  "Superb": "Medium", 
  "Laura": "Medium",
  "Envaq iV": "Large"
  },
  "Ford": { 
  "Mustang Mach-E": "Medium", 
  "Fiesta": "Medium", 
  "Freestyle": "Medium", 
  "EcoSport": "Medium",
  "Figo": "Small", 
  "Figo Aspire": "Medium", 
  "Endeavour": "Large", 
  "Aspire": "Medium",
  "Explorer": "Large", 
  "F-150 Lightning": "Large", 
  "E-Transit": "Large"
  },
  "Toyota": { 
  "Urban Cruiser Hyryder": "Medium", 
  "Innova Hycross": "Large", 
  "Hilux": "Large",
  "Etios Liva": "Small", 
  "Glanza": "Small", 
  "Fortuner": "Large", 
  "Innova": "Large",
  "Vellfire": "Large", 
  "Urban Cruiser": "Medium", 
  "Innova Crysta": "Large",
  "Corolla Altis": "Medium", 
  "Yaris": "Medium", 
  "Camry": "Medium", 
  "Etios": "Medium",
  "Etios Cross": "Small", 
  "bZ4X": "Large"
  },
  "Lexus": { 
  "ES": "Large", 
  "GX": "Large", 
  "IS": "Large", 
  "LS": "Large", 
  "LX": "Large",
  "NX": "Large", 
  "RC": "Large", 
  "RX": "Large", 
  "UX": "Large", 
  "RZ 450e": "Large"
  },
  "Bentley": { 
  "Bentayga": "Large", 
  "Continental GT": "Large", 
  "Flying Spur": "Large", 
  "Mulsanne": "Large"
  },
  "Premier": { 
  "Rio": "Large", 
  "Padmini": "Large"
  },
  "Chevrolet": { 
  "Captiva": "Large", 
  "Camaro": "Large", 
  "Colorado": "Large", 
  "Corvette": "Large",
  "Equinox": "Large", 
  "Impala": "Large", 
  "Malibu": "Large", 
  "Silverado": "Large",
  "Suburban": "Large", 
  "Tahoe": "Large", 
  "Trailblazer": "Large", 
  "Traverse": "Large",
  "Trax": "Large", 
  "Cruze": "Medium", 
  "Silverado EV": "Medium"
  },
  "Genesis": { 
  "G70": "Large", 
  "G80": "Large", 
  "G90": "Large", 
  "GV60": "Large", 
  "Electrified G80": "Large"
  },
  "Citroën": { 
  "C3": "Small", 
  "C4": "Medium", 
  "C4 Cactus": "Medium", 
  "C5 Aircross": "Large",
  "Berlingo": "Medium", 
  "ë-C4": "Medium", 
  "Ami": "Medium", 
  "Citroen C3 Aircross": "Small",
  "Citroen C3": "Small", 
  "Citroen C5 Aircross": "Medium", 
  "Citroen eC3": "Small",
  "Basalt": "Medium"
  },
  "Tesla": { 
  "Model 3": "Large", 
  "Model S": "Large", 
  "Model X": "Large", 
  "Model Y": "Large",
  "Roadster": "Large", 
  "Cybertruck": "Large"
  },
  "Fisker": { 
  "Ocean": "Large", 
  "EMotion": "Large", 
  "Pear": "Large"
  },
  "MG": { 
  "Gloster": "Large", 
  "Hector": "Large", 
  "Hector Plus": "Large", 
  "Astor": "Medium",
  "ZS EV": "Medium", 
  "Comet EV": "Small", 
  "Windsor EV": "Large", 
  "MG4 EV": "Large"
  },
  "Kia": { 
  "Seltos": "Medium", 
  "Carens": "Large", 
  "Carnival": "Large", 
  "Sonet": "Medium",
  "EV6": "Large", 
  "Soul EV": "Medium", 
  "Niro EV": "Large", 
  "EV3": "Medium", 
  "EV5": "Medium"
  },
  "Jeep": { 
  "Wrangler": "Large", 
  "Compass": "Large", 
  "Meridian": "Large", 
  "Grand Cherokee": "Large",
  "Avenger EV": "Large", 
  "Rubicon": "Large"
  },
  "Nissan": { 
  "Kicks": "Medium", 
  "Magnite": "Medium", 
  "Micra": "Small", 
  "Sunny": "Medium",
  "Terrano": "Medium", 
  "Ariya": "Large", 
  "GT-R": "Large", 
  "Leaf": "Large"
  },
  "Fiat": { 
  "Punto": "Small", 
  "Linea": "Medium", 
  "Abarth Punto": "Large", 
  "Avventura": "Large",
  "500 Electric": "Medium"
  },
  "Datsun": { 
  "GO": "Small", 
  "RediGo": "Small"
  },
  "BMW": { 
  "X1": "Large", 
  "M2 Coupé": "Large", 
  "X5": "Large", 
  "X3": "Large", 
  "X4": "Large",
  "XM": "Large", 
  "M3": "Large", 
  "iX": "Large", 
  "X6": "Large", 
  "iX3": "Large",
  "i7": "Large", 
  "iX1": "Large", 
  "M4": "Large", 
  "M8": "Large", 
  "4 Series Gran Coupe": "Large",
  "5 Series": "Large", 
  "3 Series": "Large", 
  "7 Series": "Large", 
  "Z4": "Large", 
  "M5": "Large",
  "6 Series": "Large", 
  "M340i": "Large", 
  "8 Series": "Large", 
  "M8 Cabriolet": "Large",
  "iX (Electric)": "Large", 
  "i3": "Large", 
  "i4": "Large", 
  "i5": "Large"
  },
  "Mercedes": { 
  "C Class": "Large", 
  "S class 350": "Large", 
  "E220d": "Large", 
  "E Class": "Large",
  "GLC": "Large", 
  "GLE Coupe": "Large", 
  "GLA": "Large", 
  "CLA": "Large",
  "GLS": "Large", 
  "SL Roadster": "Large", 
  "GLB": "Large", 
  "EQB": "Large",
  "EQE SUV": "Large", 
  "EQC": "Large", 
  "EQS AMG": "Large", 
  "A-Class Limousine": "Large",
  "EQS (Electric)": "Large", 
  "G-Class G580": "Large"
  },
  "Audi": { 
  "A6": "Medium", 
  "A3": "Medium", 
  "A4": "Medium", 
  "Q8": "Large", 
  "A8": "Medium",
  "Q3": "Large", 
  "Q5": "Large", 
  "Q7": "Large", 
  "S5": "Medium", 
  "R8": "Large",
  "e-tron": "Large", 
  "RS Q8": "Large", 
  "RS5": "Large", 
  "Q2": "Large", 
  "S3 Sedan": "Medium",
  "A1": "Medium", 
  "A7": "Medium", 
  "RS 6": "Large", 
  "S4": "Large", 
  "RS4": "Large",
  "S6": "Medium", 
  "A5": "Medium", 
  "A6 Allroad": "Large", 
  "e-tron GT": "Large",
  "Q6 e-tron": "Large", 
  "Q8 e-tron": "Large"
  },
  "Force": { 
  "Gurkha": "Large", 
  "Trax": "Large", 
  "Traveller": "Large", 
  "Urbania": "Large",
  "Citiline": "Large", 
  "Monobus": "Large"
  },
  "Nexa": { 
  "Baleno": "Small", 
  "Ignis": "Small", 
  "Ciaz": "Medium", 
  "S-Cross": "Medium", 
  "XL6": "Medium"
  },
  "Jaguar": { 
  "XE": "Medium", 
  "XF": "Medium", 
  "XJ": "Medium", 
  "F-Type": "Large", 
  "F-Pace": "Large",
  "E-Pace": "Large", 
  "I-Pace": "Large"
  },
  "Ferrari": { 
  "Roma Spider": "Large", 
  "488 GTB": "Large", 
  "F8 Tributo": "Large", 
  "F8 Spider": "Large",
  "SF90 Stradale": "Large", 
  "SF90": "Large", 
  "Portofino": "Large", 
  "Roma": "Large",
  "812 Superfast": "Large", 
  "LaFerrari": "Large", 
  "488 Pista": "Large", 
  "GTC4 Lusso": "Large"
  },
  "Porsche": { 
  "911": "Large", 
  "718 Cayman": "Large", 
  "Panamera": "Large", 
  "Macan": "Large",
  "Taycan": "Large", 
  "Cayenne": "Large", 
  "Boxster": "Large", 
  "Carrera GT": "Large",
  "918 Spyder": "Large", 
  "Carrera": "Large", 
  "Macan EV": "Large", 
  "Boxster EV": "Large"
  },
  "Land Rover": { 
  "Range Rover": "Large", 
  "Range Rover Sport": "Large", 
  "Range Rover Velar": "Large",
  "Range Rover Evoque": "Large", 
  "Defender": "Large", 
  "Land Rover Defender": "Large"
  },
  "Hindustan Ambassador": { 
  "Mark I": "Medium", 
  "Mark II": "Medium", 
  "Mark III": "Medium", 
  "Mark IV": "Medium",
  "Nova": "Medium", 
  "Avigo": "Medium"
  },
  "Polestar": { 
  "2": "Large", 
  "3": "Large", 
  "4": "Large", 
  "5": "Large"
  },
  "Lucid Motors": { 
  "Air": "Large", 
  "Gravity": "Large"
  },
  "Rivian": { 
  "R1T": "Large", 
  "R1S": "Large"
  },
  "Xpeng Motors": { 
  "G9": "Large", 
  "G3i": "Large", 
  "P5": "Large", 
  "P7": "Large"
  },
  "Rolls-Royce": { 
  "Spectre": "Large"
  },
  "GMC": { 
  "Hummer EV": "Large", 
  "Sierra EV Denali": "Large"
  },
  "Lamborghini": { 
  "Huracan Evo": "Large"
  }
}
